import graph from "@irati/utils/services/graph"
import {driver} from "./driver"


const service = {}

export const question = `
  id: uuid
  Etag: etag
  text
  type
  status
  driverId: driverUuid
  groupIds: groupUuids
  contentId
  driver: driverV2 @include(if: $withQuestionDriver) {${driver}}
  answers {
    text
    value
    contentId
  }
`


service.list = (variables, options = {}) => {
  const query = `
  query Questions($withSchedule: String, $minOpenedAt: String, $teamId: String, $withQuestionDriver: Boolean = false) {
    questions: questionsV2(withSchedule: $withSchedule, teamId: $teamId, minOpenedAt: $minOpenedAt) {
      results {
        ${question}
      }
    }
  }
  `

  return graph({query, variables}, options).then((data) => data.questions.results)
}


export const listQuestions = service.list

export default service
